<template>
  <div class="tooltip-wrapper"
       @mouseenter="focusTrue"
       @mouseleave="focusFalse">
    <transition name="fade-opacity-lazy">
      <div class="label-container" v-if="focusParam">
        {{ labelText }}
      </div>
    </transition>
    <slot/>
  </div>
</template>

<script>
export default {
  name: "TooltipCustom",
  props: {
    labelText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      focusParam: false
    }
  },
}
</script>

<style scoped lang="scss">
.tooltip-wrapper {
  position: relative;
  width: fit-content !important;
  .label-container {
    max-width: 300px;
    width: max-content;
    text-align: center;
    pointer-events: none;
    z-index: 100;
    right: 0;
    top: calc(100% + 8px);
    border-radius: 16px;
    padding: 6px 12px;
    position: absolute;
    background: var(--color-white-smoke);
    border: 1px solid var(--color-dark-purple);
    color: var(--color-dark-purple);
    font-size: 14px;
  }
}
</style>